import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'gatsby';

import { ButtonStyles } from '../Button/styles';

const LinkStyles = css`
  font-family: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-size: 19px;
  color: ${themeGet('colors.text-dark')};
  font-weight: ${themeGet('font-weights.semi-bold')};
  padding-bottom: 4px;
  border-bottom: 1px solid ${themeGet('colors.orange')};

  &:hover,
  &:focus {
    color: ${themeGet('colors.darkest-orange')};
    border-bottom: 1px solid ${themeGet('colors.orange')};
  }

  &.inline {
    padding-bottom: 0px;
    border-bottom: none;

    &:hover,
    &:focus {
      opacity: 0.8;
      border-bottom: none;
    }
  }

  &.unstyled {
    display: inline;
    border: none;
    font-weight: normal;
    color: initial;
    padding: 0;

    &:hover,
    &:focus {
      color: initial;
      border-bottom: none;
    }
  }

  ${ButtonStyles}
`;

export const InternalStyledLink = styled(Link)`
  ${LinkStyles}
`;

export const ExternalStyledLink = styled.a.attrs(({ isSpecialLink }) => ({
  target: isSpecialLink ? '' : '_blank',
  rel: isSpecialLink ? '' : 'noopener noreferrer',
}))`
  ${LinkStyles}
`;
